var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-container"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.svg")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }